import type { ComponentPropsWithoutRef } from 'react'

const ListItemParagraph = ({ className = '', ...props }: ComponentPropsWithoutRef<'dl'>) => (
  <dl className={`flex items-center p-4 ${className}`} {...props} />
)

export default ListItemParagraph
